import React, { useState } from "react";
import { Chip, InputAdornment, Stack } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CardTextField from "../CardTextField";

interface SearchTagSelectorProps {
  selectedTags: string[];
  setFieldValue: (field: string, value: string[]) => void;
  name?: string;
}

export const SearchTagSelector: React.FC<SearchTagSelectorProps> = ({
  selectedTags,
  setFieldValue,
  name = "tags",
}) => {
  const [search, setSearch] = useState("");

  const addTag = (tag: string) => {
    const trimmed = tag.trim();
    if (trimmed && !selectedTags.includes(trimmed) && selectedTags.length < 3) {
      const updatedTags = [...selectedTags, trimmed];
      setFieldValue(name, updatedTags);
    }
  };

  const removeTag = (tag: string) => {
    const updatedTags = selectedTags.filter((t) => t !== tag);
    setFieldValue(name, updatedTags);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag(search);
      setSearch("");
    }
  };

  // const handleChipClick = (tag: string) => {
  //   addTag(tag);
  //   setSearch("");
  // };

  // const filteredTags = allTags.filter(
  //   (tag) =>
  //     tag.toLowerCase().includes(search.toLowerCase()) &&
  //     !selectedTags.includes(tag)
  // );

  return (
    <Stack spacing={1}>
      <CardTextField
        placeholder={
          selectedTags.length >= 3
            ? `Maximum 3 ${name} selected`
            : `Type and enter to add ${name}`
        }
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleKeyDown}
        InputProps={{
          startAdornment: (
            <>
              {selectedTags.map((tag) => (
                <Chip
                  key={tag}
                  label={tag}
                  onDelete={() => removeTag(tag)}
                  sx={{ mx: 0.5 }}
                />
              ))}
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#9CA3AF" }} />
              </InputAdornment>
            </>
          ),
        }}
        disabled={selectedTags.length >= 3}
      />
    </Stack>
  );
};
